import React, { Component } from "reactn";

import { AssetType, ASSET_FILETYPE } from "common/constants";
import getLogger, { LogGroup } from "js/core/logger";
import { ds } from "js/core/models/dataService";
import ux from "js/core/services/userExperiences";
import { getImageProperties, trimWhiteEdges } from "js/core/utilities/imageUtilities";
import isConnected from "js/core/utilities/isConnected";
import { loadImage } from "js/core/utilities/promiseHelper";
import { ShowOfflineDialog, ShowWarningDialog } from "js/react/components/Dialogs/BaseDialog";
import { ImageThumbnail } from "js/react/components/ImageThumbnail";
import Spinner from "js/react/components/Spinner";

const logger = getLogger(LogGroup.ASSETS);

class LogoPreview extends Component {
    state = {
        isImporting: false
    };

    importLogo = async () => {
        const {
            addAssetCallback,
            handleConfirm,
            src,
            name,
        } = this.props;

        if (!isConnected.connected) {
            ShowOfflineDialog();
            return;
        }

        if (this.state.isImporting) {
            return;
        }
        this.setState({ isImporting: true });

        try {
            const tempImage = await loadImage(src, null, "anonymous");
            const updatedDataURL = trimWhiteEdges(tempImage);
            const image = await loadImage(updatedDataURL);
            const imageProperties = getImageProperties(image, {
                type: "image/png"
            });

            imageProperties.hasSolidBackground = true;
            imageProperties.imageBackgroundColor = "#FFFFFF";

            const asset = await ds.assets.getOrCreateImage({
                url: updatedDataURL,
                name,
                fileType: ASSET_FILETYPE.PNG,
                assetType: AssetType.LOGO,
                metadata: {
                    source: "logo"
                },
                imagePropsOverride: imageProperties
            });

            addAssetCallback(asset);
            this.setState({ isImporting: false });
            handleConfirm();
        } catch (err) {
            ShowWarningDialog({
                title: "Sorry!",
                message: "We seem to be having trouble accessing this image. Please try again.",
            });
            this.setState({ isImporting: false });
            logger.error(err, "[LogoPreview] importLogo() failed");
            ux.addAssetToSlideElement.fail({ error: err }, null, true, true);
        }
    };

    render() {
        const { src, width } = this.props;
        const { isImporting } = this.state;

        return (
            <div
                className="logo-wrapper"
                onClick={this.importLogo}
                style={{ width: width, height: width }}
            >
                {isImporting && <Spinner />}
                <ImageThumbnail src={src} />
            </div>
        );
    }
}

export default LogoPreview;
